import {Dispatch} from "redux";

import {catch400, catch403, patchRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {postApplicationTypes} from "../actions/after_post_application";
import {ConsumerSegment} from "../types/ConsumerSegment";
import {IApplicationData} from "../types/IApplicationData";
import {alertFormSuccessMessage} from "../utils/form/application_form_alert_text";

interface IExtendedApplication extends IApplicationData {
    consumer_segment: ConsumerSegment;
}

const applicationPatchApiLink = apiLink.application.detail;
export const patchApplication = (uuid: string, jsonData: Partial<IExtendedApplication>, storeHash: string) => (dispatch: Dispatch) => {
    dispatch({type: postApplicationTypes.start, id: storeHash});

    return patchRequest({}, applicationPatchApiLink({})({uuid}), jsonData)
        .then((application: IApplicationData) => {
            dispatch({type: postApplicationTypes.success, id: storeHash, result: application});
            dispatch(addSuccessNotification(alertFormSuccessMessage));
            return application;
        })
        .catch(
            catch400((error) => {
                dispatch({type: postApplicationTypes.error, id: storeHash, error: error.appError});
                console.error("Popraw błędy formularza");
            })
        )
        .catch(
            catch403((err) => {
                dispatch({type: postApplicationTypes.error, id: storeHash, error: null});
                notifyBugsnag(err, "applicationPatch: catch 403", err.responseError ?? {});
            })
        );
};
import {Dispatch} from "redux";

import {catch400, catch403, patchRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addSuccessNotification} from "../../notifications/utils/add_success_notification";
import {postApplicationTypes} from "../actions/after_post_application";
import {ConsumerSegment} from "../types/ConsumerSegment";
import {IApplicationData} from "../types/IApplicationData";
import {alertFormSuccessMessage} from "../utils/form/application_form_alert_text";

interface IExtendedApplication extends IApplicationData {
    consumer_segment: ConsumerSegment;
}

const applicationPatchApiLink = apiLink.application.detail;
export const patchApplication = (uuid: string, jsonData: Partial<IExtendedApplication>, storeHash: string) => (dispatch: Dispatch) => {
    dispatch({type: postApplicationTypes.start, id: storeHash});

    return patchRequest({}, applicationPatchApiLink({})({uuid}), jsonData)
        .then((application: IApplicationData) => {
            dispatch({type: postApplicationTypes.success, id: storeHash, result: application});
            dispatch(addSuccessNotification(alertFormSuccessMessage));
            return application;
        })
        .catch(
            catch400((error) => {
                dispatch({type: postApplicationTypes.error, id: storeHash, error: error.appError});
                console.error("Popraw błędy formularza");
            })
        )
        .catch(
            catch403((err) => {
                dispatch({type: postApplicationTypes.error, id: storeHash, error: null});
                notifyBugsnag(err, "applicationPatch: catch 403", err.responseError ?? {});
            })
        );
};
